import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {setPageTitle} from "../../../modules/application/pages";
import {getMetabaseDashboardURL} from "../../../modules/metabase_dashboard";
import FacilityFilter from "./facility-filter.js";
import Constants from "../../../constants/constants";
import "./metabase-dashboard.css";

class MetabaseDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchingURL: false,
            dashboardURL: "",
            failedToLoad: false
        };

        this.props.dispatch(setPageTitle("Stats Dashboard"));
    }

    async componentDidMount() {
        this.updateMetabaseDashboard(-1);
    }

    async updateMetabaseDashboard(organizationID) {
        const {token} = this.props;
        const {fetchingURL} = this.state;

        if (fetchingURL) {
            return;
        }

        this.setState({fetchingURL: true});
        
        let dashboardURLResponse = await getMetabaseDashboardURL(token, organizationID);

        if (dashboardURLResponse && dashboardURLResponse.data && dashboardURLResponse.data.success) {
            this.setState({ dashboardURL: dashboardURLResponse.data.dashboard_url, fetchingURL: false});
        }
        else {
            this.setState({failedToLoad: true, fetchingURL: false});
        }
    }


    render () {
        const {dashboardURL, failedToLoad, fetchingURL} = this.state;
        const {currentUser, token} = this.props;

        let isBigAdmin = currentUser.roleLevel === Constants.REGIONAL_ADMIN_ROLE_LEVEL  || currentUser.roleLevel === Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL;

        if (failedToLoad) {
            return (
                <div>Dashboard is presently unavailable. Please, try again later.</div>
            );
        }
        else if (fetchingURL) {
            return (
                <div className='metabase_loader'>
                    {isBigAdmin && <FacilityFilter handle_facility_filter_change={this.updateMetabaseDashboard.bind(this)} token={token} />}
                    <span>Loading dashboard...</span> <i className='fa fa-spin fa-spinner'></i>
                </div>
            );
        }
        else {
            return (
                <div className='metabase-container'>
                    {isBigAdmin && <FacilityFilter handle_facility_filter_change={this.updateMetabaseDashboard.bind(this)} token={token} />}
                    <iframe title='Stats' className='metabase-iframe' src={dashboardURL}/>
                </div>
            );
            
        }
    }
}


const withState = connect(state => {
    const {user} = state;

    return {
        token: user.token,
        currentUser: user,
    };
});

export default withRouter(withState(MetabaseDashboard));


// WEBPACK FOOTER //
// ./src/components/containers/metabase-dashboard/metabase-dashboard.js